import React from "react";

function Footer() {
  return (
    <footer>
      <p>Made by Suneel. Copyright ⓒ {new Date().getFullYear()}</p>
    </footer>
  );
}

export default Footer;
